module.exports = __webpack_public_path__ + "img/logo-white.864a6936.png";